export const ENV = {
  PRODUCTION: 'prod',
  GRAY: 'gray',
  TEST: 'test',
  DEV: 'dev',
};

export const SERVER_URL = {
  [ENV.DEV]: '//flowpack.sparta.html5.qq.com',
  [ENV.TEST]: '//flowpack213.3g.qq.com',
  [ENV.PRODUCTION]: '//flowpack.3g.qq.com',
  [ENV.GRAY]: '//flowpack.3g.qq.com/gray',
};

export const LOGIN_URL = {
  [ENV.DEV]: '//login-obd-213.testsite.woa.com/v1',
  [ENV.TEST]: '//login-obd-213.3g.qq.com/outer/v1',
  [ENV.GRAY]: '//login-obd.3g.qq.com/outer/v1',
  [ENV.PRODUCTION]: '//login-obd.3g.qq.com/outer/v1',
};

export const AMS_URL = {
  [ENV.DEV]: '//login-obd.sparta.html5.qq.com/v1',
  [ENV.TEST]: '//login-obd-213.3g.qq.com/outer/v1',
  [ENV.GRAY]: '//login-obd.3g.qq.com/outer/v1',
  [ENV.PRODUCTION]: '//login-obd.3g.qq.com/outer/v1',
};

export const ORDER_HOST = {
  [ENV.DEV]: '//h5-test.flow.qq.com/',
  [ENV.TEST]: '//h5-special.flow.qq.com/',
  [ENV.GRAY]: '//h5.flow.qq.com/',
  [ENV.PRODUCTION]: '//h5.flow.qq.com/',
};

export const BENEFIT_URL = {
  [ENV.DEV]: 'https://benefit-213.flow.qq.com',
  [ENV.TEST]: 'https://benefit-213.flow.qq.com',
  [ENV.GRAY]: 'https://benefit.flow.qq.com/gray',
  [ENV.PRODUCTION]: 'https://benefit.flow.qq.com',
};

export const REPORT_URL = {
  [ENV.DEV]: 'https://data-collect.testsite.woa.com/v1/flowpackReport',
  [ENV.TEST]: 'https://data-collect.testsite.woa.com/v1/flowpackReport',
  [ENV.GRAY]: 'https://data-collect.flow.qq.com/v1/flowpackReport',
  [ENV.PRODUCTION]: 'https://data-collect.flow.qq.com/v1/flowpackReport',
};

// 定向流量Node
export const NODE_SERVER_URL = {
  [ENV.DEV]: '//flowpack213.3g.qq.com/tyche/flowPackNode',
  [ENV.TEST]: '//flowpack213.3g.qq.com/tyche/flowPackNode',
  [ENV.PRODUCTION]: '//tyche.obd.qq.com/flowPackNode',
  [ENV.GRAY]: '//tyche.obd.qq.com/gray/flowPackNode',
};

export const GATEWAY_URL = {
  [ENV.DEV]: '//flowpack213.3g.qq.com/tyche/flowpack',
  [ENV.TEST]: '//flowpack213.3g.qq.com/tyche/flowpack',
  [ENV.PRODUCTION]: '//tyche.obd.qq.com/flowpack',
  [ENV.GRAY]: '//tyche.obd.qq.com/gray/flowpack',
};
